// src/app/private/components/bug-activity-timeline/bug-activity-timeline.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { BugService } from 'src/app/private/services/bug.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-bug-activity-timeline',
  templateUrl: './bug-activity-timeline.component.html',
  styleUrls: ['./bug-activity-timeline.component.scss']
})
export class BugActivityTimelineComponent implements OnInit {
  @Input() bugId!: number;

  items: any[] = [];
  loading = false;
  page = 1;
  size = 25;
  total = 0;

  constructor(private activityService: BugService,private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.bugId) this.load();
  }
safeDescription(desc: any): SafeHtml {
  if (!desc || desc === 'null' || desc === 'undefined') {
    return this.sanitizer.bypassSecurityTrustHtml(
      '<span class="no-desc">No description available.</span>'
    );
  }

  // Convert to string in case server sends non-string
  let cleanDesc = String(desc);

  // Replace internal words
  cleanDesc = cleanDesc
    .replace(/undefined/gi, 'N/A')
    .replace(/null/gi, 'N/A');

  return this.sanitizer.bypassSecurityTrustHtml(cleanDesc);
}
  async load(page = 1) {
    this.loading = true;
    this.page = page;
    let payload = {
      bug_id: this.bugId,
      page: this.page,
      size: this.size
    };
    this.activityService.getBugActivityLog(payload)
      .subscribe({
        next: (res: any) => {
          this.items = res.items || [];
          this.total = res.total || 0;
          this.loading = false;
        },
        error: (err) => {
          console.error('activity load error', err);
          this.loading = false;
        }
      });
  }

  // small UI helpers
  formatTime(ts: string) {
    const d = new Date(ts);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  iconFor(action: string) {
    switch (action) {
      case 'comment': return '💬';
      case 'status_change': return '🔁';
      case 'assignment': return '👥';
      case 'priority_change': return '⚠️';
      case 'reproduction_increment': return '🔁';
      case 'create': return '🟢';
      default: return '📝';
    }
  }

prettyAction(type: string) {
  return type.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

highlightClass(type: string) {
  const map: any = {
    priority_change: "highlight-priority",
    severity_change: "highlight-severity",
    status_change: "highlight-status",
    type_change: "highlight-type",
    assignment: "highlight-assigned",
    due_date_change: "highlight-due",
    attachments_change: "highlight-attachments",
    internal_comments_change: "highlight-comments"
  };

  return map[type] || "highlight-default";
}
}
